export const FUTURE_ENTRIES_MODAL_PT_BR = {
	title: "Lançamentos Futuros",
	search: "Buscar",
	return: "Voltar",
	totalEntries: "{{count}} lançamento",
	totalEntries_plural: "{{count}} lançamentos",
	totalForMonth: "Total de Lançamentos",
	columns: {
		month: "Mês",
		group: "AGRUPAMENTO",
		total: "Total",
		type: "TIPO",
		category: "CATEGORIA",
		originDestination: "ORIGEM/DESTINO",
		observation: "OBSERVAÇÃO",
		competenceDate: "DATA DE COMPETÊNCIA",
		liquidationDate: "DATA DE LIQUIDAÇÃO",
		value: "VALOR",
		totalReleases: "Total de Lançamentos",
		emptyText: "Nenhum lançamento futuro encontrado",
	},
	excel: {
		title: "Lançamentos Futuros - {{startDate}} a {{endDate}}",
		fileName: "lancamentos-futuros-{{startDate}}-{{endDate}}",
	},
};

export type FutureEntriesModalTranslations = typeof FUTURE_ENTRIES_MODAL_PT_BR;
